import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Projects from './components/Projects';
import AdditionalProjects from './components/AdditionalProjects';
import About from './components/About';
import Education from './components/Education';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App min-h-screen bg-zinc-950 text-white overflow-x-hidden">
      <Header />
      <Hero />
      <Projects />
      <AdditionalProjects />
      <About />
      <Education />
      <Footer />
    </div>
  );
}

export default App;
